<template>
  <div></div>
</template>


<script>

import { localSave, localRead } from '@/utils/util';

export default {
  name: 'AutoPlay',
  data() {
    return {
      timer: 0,
      xiangMuIndex: 0,
    };
  },
  watch: {
    $route: {
      handler(val) {
        clearInterval(this.timer);
        const autoplayLocal = localRead('autoPlay');
        let autoPlay = false;
        if (autoplayLocal && autoplayLocal !== 'undefined') {
          autoPlay = JSON.parse(autoplayLocal);
        }
        if (autoPlay === true) {
          this.autoplay(val.name);
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    autoplay(name) {
      const vm = this;
      const time = name === 'index' ? 60 * 20 : 30;

      // vm.timer = setTimeout(() => {
      //   const xiangMuID = vm.getXiangMuID();
      //   if (!xiangMuID) {
      //     return;
      //   }
      //   switch (name) {
      //     case 'index':
      //       this.$router.push({
      //         path: `/image`,
      //       });
      //       break;
      //     case 'situation':
      //       this.$router.push({
      //         path: `/personnel/${xiangMuID}`,
      //       });
      //       break;
      //     case 'personnel':
      //       this.$router.push({
      //         path: `/quality/${xiangMuID}`,
      //       });
      //       break;
      //     case 'quality':
      //       this.$router.push({
      //         path: '/',
      //       });
      //       break;
      //     default:
      //   }
      // }, time * 1000);
    },
    getXiangMuID() {
      const vm = this;
      const xiangMu = localRead('xiangMu');
      if (xiangMu === '') {
        return 0;
      }
      const xiangMuArr = JSON.parse(xiangMu);
      if (vm.$route.name === 'quality') {
        vm.xiangMuIndex = vm.xiangMuIndex === xiangMuArr.length - 1 ? 0 : vm.xiangMuIndex + 1;
      }
      return xiangMuArr[vm.xiangMuIndex].id;
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/common/AutoPlay.vue